import React, { useState, useEffect, useRef } from 'react';
import { Input, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getMyCartList } from '@/api/cart';
import { getNotReadMessageNum } from '@/api/message';
import { eventBus } from '@/utils/eventBus';
import styles from './SideBar.module.scss';
import icon1 from '@/assets/images/路径 1627@2x.png';
import icon2 from '@/assets/images/路径 1628@2x.png';
import icon3 from '@/assets/images/组 2467@2x.png';
import icon4 from '@/assets/images/组 2468@2x.png';
import icon5 from '@/assets/images/组 3123@2x.png';
import icon6 from '@/assets/images/264e81a2a3c5cc322f96bd707172b5ad.png';
import { useTranslation } from 'react-i18next';


import { useAppSelector } from '@/store/hooks';

interface SideBarProps {
  // children: React.ReactNode;
  // getMessage?: (str: string) => void; // 可选的回调函数
}

const SideBar: React.FC<SideBarProps> = ({ }) => {
  //聊天联系人列表定时器
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  //路由跳转对象
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const token = useAppSelector((state) => state.user.token);


  const [menuList, setMenuList] = useState([
    { key: 'Home', name: t('common.Home'), num: 0, img: icon1, path: '/' },
    { key: 'Message', name: t('common.Message'), num: 0, img: icon2, path: '/chatList' },
    { key: 'Cart', name: t('common.Cart'), num: 0, img: icon3, path: '/yourtownloop/cart' },
    { key: 'Account', name: t('common.Account'), num: 0, img: icon5, path: '/yourtownloop' },
    { key: 'LiveNow', name: t('common.LiveNow'), num: 0, img: icon6, path: '/liveNow' },
  ]);
  // useEffect(() => {
  //   // 在组件销毁时清除定时器
  //   return () => {
  //     if (timerRef.current) clearInterval(timerRef.current);
  //   };
  // }, []);
  const getNotReadMessageNumAction = () => {
    getNotReadMessageNum().then((res) => {
      if (res.code == 200) {
        const data = res.data;
        setMenuList(prev => {
          return prev.map((item: any) => {
            if (item.key == 'Message') {
              return { ...item, num: data };
            }
            return item;
          });
        });
      }
    });
  };


  useEffect(() => {
    if (token) {


      getNotReadMessageNumAction();
      // if (timerRef.current) clearInterval(timerRef.current);
      // // 开启定时器
      // timerRef.current = setInterval(() => {
      //   getNotReadMessageNumAction(); 
      // }, 10000); // 每 10 秒一次

      getMyCartList({}).then((res) => {
        if (res.code == 200) {
          const cartList = res.data;
          const cartNum = cartList.reduce((total: number, item: any) => total + item.quantity, 0);
          setMenuList(prev => {
            return prev.map((item: any) => {
              if (item.key == 'Cart') {
                return { ...item, num: cartNum };
              }
              return item;
            });
          });
        }
      });
    }

  }, [token]);

  useEffect(()=>{
    const handler = (num:number) => {
      debugger
      setMenuList(prev => {
        return prev.map((item: any) => {
          if (item.key == 'Cart') {
            return { ...item, num: num+item.num };
          }
          return item;
        });
      });
    };
    eventBus.on('addCart', handler as any);
    return ()=>{
      if (timerRef.current) clearInterval(timerRef.current);
      eventBus.off('addCart', handler as any);
    }
  },[])
  useEffect(() => {
    // 当语言改变时会重新执行此 effect
    //console.log('Language changed to:', i18n.language);
    // 执行需要在语言切换时进行的操作
    setMenuList([
      { key: 'Home', name: t('common.Home'), num: 0, img: icon1, path: '/' },
      { key: 'Message', name: t('common.Message'), num: 0, img: icon2, path: '/chatList' },
      { key: 'Cart', name: t('common.Cart'), num: 0, img: icon3, path: '/yourtownloop/cart' },
      { key: 'Account', name: t('common.Account'), num: 0, img: icon5, path: '/yourtownloop' },
      { key: 'LiveNow', name: t('common.LiveNow'), num: 0, img: icon6, path: '/liveNow' },
    ])
  }, [i18n.language]); // 将语言作为依赖项
  return (
    <div className={styles['side-bar']}>
      {
        menuList.map((item, index) => (
          <div className={styles['menu-item']} key={index} onClick={() => navigate(item.path)}>
            <img src={item.img} alt="" className={styles['menu-icon']} />
            <div className={styles['menu-name']}>{item.name}</div>
            {item.num > 0 && <div className={styles['menu-num']}>{item.num <= 99 ? item.num : '99+'}</div>}
          </div>
        ))
      }

      {/* <div className={styles['menu-item']}>
        <img src={icon4} alt="" className={styles['menu-icon']} />
        <div className={styles['menu-name']}>More</div>
      </div> */}

    </div>
  );
};

export default SideBar; 